var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_1507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5868 20.5864C22.3903 20.7695 22.2326 20.9903 22.1233 21.2357C22.014 21.481 21.9552 21.7458 21.9505 22.0144C21.9458 22.2829 21.9952 22.5497 22.0958 22.7987C22.1963 23.0477 22.3461 23.2739 22.536 23.4639C22.7259 23.6538 22.9521 23.8035 23.2012 23.9041C23.4502 24.0047 23.7169 24.0541 23.9855 24.0493C24.254 24.0446 24.5189 23.9858 24.7642 23.8765C25.0095 23.7672 25.2303 23.6096 25.4134 23.4131",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1533 17.3868C23.4342 17.3518 23.7169 17.334 24 17.3335C28.6667 17.3335 30.6667 22.0002 30.6667 22.0002C30.3686 22.6382 29.9948 23.2381 29.5533 23.7868",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4066 18.4067C19.0808 19.3098 18.0198 20.5502 17.3333 22.0001C17.3333 22.0001 19.3333 26.6667 23.9999 26.6667C25.2772 26.6702 26.5271 26.2968 27.5933 25.5934",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 15.3335L30.6666 28.6668",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_1507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeClosed);
export default __webpack_public_path__ + "static/media/PasswordEyeClosed.ad3e42e86821193aea4c135948a72a1f.svg";
export { ForwardRef as ReactComponent };